import SchedulingServicesRegistration from './SchedulingServicesRegistration';

export default SchedulingServicesRegistration;